import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { UserProgrammeOverview } from "../types/UserProgrammeOverview";

interface ProgrammeAndJourneyId {
  journeyId: string;
  programmeId: string;
}
interface GetUserProgrammeOverviewsRequest {
  profileId: string;
  programmeAndJourneyIds: ProgrammeAndJourneyId[];
}

export const programmeApiV2 = createApi({
  reducerPath: "programmeApiV2",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.programmeService}/v2/`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: (builder) => ({
    getProgrammeOverviews: builder.query<
      UserProgrammeOverview[],
      GetUserProgrammeOverviewsRequest
    >({
      query: (data) => {
        return `/user-programme/user/${
          data.profileId
        }/overview?ids=${encodeURIComponent(
          JSON.stringify(data.programmeAndJourneyIds)
        )}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProgrammeOverviewsQuery } = programmeApiV2;
